import axios from 'axios';

const baseURL =
  import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001/api';

const api = axios.create({
  baseURL,
  timeout: 100000,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  config => {
    const jwtToken = localStorage.getItem('jwtToken');

    if (jwtToken) {
      try {
        config.headers.Authorization = `Bearer ${jwtToken}`;
      } catch (error) {
        console.error('Error parsing rexiUser from localStorage:', error);
      }
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response?.status === 401 && error.request.url !== '/auth/login') {
      localStorage.removeItem('jwtToken');
    }

    return Promise.reject(error);
  }
);

export default api;
